import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Bell, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, PriorityBadge } from "@/components/common/ui";

export default function Alerts() {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState(null);
  const load = () => api.get("/alerts").then((r) => setAlerts(r.data)).catch(() => setAlerts([]));
  useEffect(() => { load(); }, []);

  const ack = async (id) => { try { await api.post(`/alerts/${id}/acknowledge`); toast.success("Alert acknowledged"); load(); } catch (e) {} };

  if (!alerts) return <div className="flex h-64 items-center justify-center text-muted-foreground"><Loader2 className="animate-spin" /></div>;

  return (
    <div>
      <PageHeader overline="Workspace" title="Active Alerts"
        description="Prioritized, cross-module alerts with acknowledgement and escalation." />
      <div className="space-y-3">
        {alerts.map((a) => (
          <div key={a.id} data-testid={`alert-row-${a.id}`} className="flex items-center gap-4 rounded-xl border bg-card p-4 shadow-sm">
            <PriorityBadge level={a.priority} />
            <div className="min-w-0 flex-1">
              <div className="font-semibold">{a.title}</div>
              <div className="text-sm text-muted-foreground">{a.detail}</div>
              <div className="mt-0.5 text-xs text-muted-foreground">{a.module}</div>
            </div>
            <button onClick={() => navigate(a.link)} className="flex items-center gap-1 rounded-md border px-3 py-1.5 text-xs font-medium hover:border-[#155EEF] hover:text-[#155EEF]">View <ArrowRight size={13} /></button>
            <button data-testid={`ack-${a.id}`} onClick={() => ack(a.id)} className="flex items-center gap-1 rounded-md bg-[#12B76A] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#0F9A5A]"><Check size={13} /> Ack</button>
          </div>
        ))}
        {alerts.length === 0 && <div className="rounded-xl border bg-card p-8 text-center text-muted-foreground">No active alerts. All clear.</div>}
      </div>
    </div>
  );
}
